/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
// Override Settings
var boostPFSInstantSearchConfig = {
	label: window.chdBoostSearchLabels || {},
	labelTranslations: {},
	search: {
		//suggestionMode: 'test',
		//suggestionPosition: 'left'
	}
};
boostPFSInstantSearchConfig.labelTranslations[(window.Shopify || {}).locale || 'en'] = window.chdBoostSearchLabels || {};
var chdSuggestionLabels = (window.chdBoostSearchLabels || {}).suggestion || {};
var chdSearchBlockLabels = {
  suggestions: chdSuggestionLabels.instantSearchSuggestionsLabel,
  collections: chdSuggestionLabels.instantSearchCollectionsLabel,
  products: chdSuggestionLabels.instantSearchProductsLabel,
  pages: chdSuggestionLabels.instantSearchPagesLabel
};
if (typeof boostPFSAppConfig !== 'undefined' && boostPFSAppConfig.settings && boostPFSAppConfig.settings.search) {
  var chdSearchSettings = boostPFSAppConfig.settings.search;
  (chdSearchSettings.suggestionBlocks || []).forEach(function (block) {
    if (chdSearchBlockLabels[block.type]) block.label = chdSearchBlockLabels[block.type];
  });
  Object.keys(chdSearchBlockLabels).forEach(function (type) {
    if (chdSearchSettings.searchPanelBlocks && chdSearchSettings.searchPanelBlocks[type] && chdSearchBlockLabels[type]) chdSearchSettings.searchPanelBlocks[type].label = chdSearchBlockLabels[type];
  });
}

(function() {
	BoostPFS.inject(this);
	InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function () {
		if (!Settings.getSettingValue('search.showSuggestionProductPrice') || !this.data) return '';
		var data = window.chdBoostMarketPriceData(this.data, (window.Shopify.currency || {}).active, boostPFSConfig.shop.currency);
		if (data.price_min === null) return '';
		var sale = data.compare_at_price_min !== null && data.compare_at_price_min > data.price_min && Settings.getSettingValue('search.showSuggestionProductSalePrice');
		var template = this.getTemplate(sale ? InstantSearchResultItemProduct.tempType.PRICE_SALE : InstantSearchResultItemProduct.tempType.PRICE);
		return template.replace(/{{regularPrice}}/g, Utils.formatMoney(data.price_min)).replace(/{{compareAtPrice}}/g, sale ? Utils.formatMoney(data.compare_at_price_min) : '');
	};
	// Boost sets its own generic placeholder during render; preserve the header's editor setting.
	var chdRenderSearchInput = SearchInput.prototype.render;
	SearchInput.prototype.render = function () {
		var result = chdRenderSearchInput.apply(this, arguments);
		var headerHint = this.$element.attr('data-chd-search-hint');
		if (headerHint) this.$element.attr({ placeholder: headerHint, 'aria-label': headerHint });
		return result;
	};
	// Shared by header suggestions and the full result page; keep the typed query visible.
	window.chdNormalizeSearch = function (query) {
		return String(query || '').replace(/\bc\s*\/?\s*c\s*[:\-]?\s*(\d+(?:[.,]\d+)?)\s*(?:mm\b)?/gi, '$1 mm')
			.replace(/\b(\d+)\s*mm\b/gi, '$1 mm').replace(/\s+/g, ' ').trim();
	};
	var chdGetSuggestions = InstantSearchApi.getSuggestionData;
	InstantSearchApi.getSuggestionData = function (query) {
		var args = Array.prototype.slice.call(arguments);
		var decoded = query;
		try { decoded = decodeURIComponent(query); } catch (_) { /* retain a literal percent sign */ }
		var normalized = window.chdNormalizeSearch(decoded);
		args[0] = decoded === query ? normalized : encodeURIComponent(normalized);
		return chdGetSuggestions.apply(this, args);
	};

  // Clear button for the Form Search
  HTMLDocument.prototype.ready = function () {
    return new Promise(function(resolve, reject) {
      if (document.readyState === 'complete') {
        resolve(document);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          resolve(document);
        });
      }
    });
  }
  
  document.ready().then(function(){
    var inputSearchFormSelector = jQ('.boost-pfs-search-input');
    var clearSearchFormSelector = jQ('.boost-pfs-search-form-btn-clear');

    if(!!inputSearchFormSelector.val()) {
      clearSearchFormSelector.show();
    }
    
    inputSearchFormSelector.on('change keydown keyup', function(){
      if(!!jQ(this).val()) {
        clearSearchFormSelector.show();
      } else {
        clearSearchFormSelector.hide();
      }
    })

    clearSearchFormSelector.on("click", function(){
      inputSearchFormSelector.val("");
      jQ(this).hide();
      inputSearchFormSelector.click();
    });
  })// End Clear button for the Form Search
  

	// Customize style of Suggestion box
	SearchInput.prototype.customizeInstantSearch = function() {
		var suggestionElement = this.$uiMenuElement;
		var searchElement = this.$element;
		var searchBoxId = this.id;
	};

  // Bind Event for input search Mobile
  var bindEventsMobile = InstantSearchMobile.prototype.bindEvents;
  InstantSearchMobile.prototype.bindEvents = function() {
    bindEventsMobile.call(this);

    var self = this;
    var searchButtonMobile = '.site-nav--mobile .search-button, .js-search-destop';
    var searchInputMobile = '.search-input-group input[type="search"], .wg-search-form .search-input';
    var searchCloseButtonMobile = '.drawer__close > button, .drawer_back a';
    jQ(searchButtonMobile).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputMobile).focus();
      self.openSuggestionMobile();
      jQ(searchCloseButtonMobile).trigger('click');

    });
  }
  
  // Bind Event for input search style 3
  var bindEvents = InstantSearchStyle3.prototype.bindEvents;
  InstantSearchStyle3.prototype.bindEvents = function() {
    bindEvents.call(this);

    var self = this;
    var searchButtonDesktop = '.site-header__links .search-button';
    var searchInputDesktop = '#SearchContainer #search-input';
    var searchCloseButtonDesktop = '.drawer__close > button';
    jQ(searchButtonDesktop).off('click').click(function(e) {
      e.preventDefault();
      //e.stopPropagation();
      jQ(searchInputDesktop).focus();
      self.openSuggestionStyle3();
      jQ(searchCloseButtonDesktop).trigger('click');

    });
  }

  // Fix search for the Flow theme
  jQ('.site-header__links .search-button').on('click', function() {
    setTimeout(function() {
      boostPFS.initSearchBox();
      if(Utils.isCollectionPage()) jQ('.search-input-group > .boost-pfs-search-box').val('');
    }, 500);
  });

  InstantSearchResultItemProduct.prototype.compileTemplate = function() {
    if (this.isShow) {
			var searchTerm = Utils.stripHtml(Globals.currentTerm);
			// Product image
			var imageHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductImage') && this.imageUrl.length) {
				imageHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.IMAGE);
				imageHTML = imageHTML.replace(/{{imageUrl}}/g, this.imageUrl);
			}
			// Product title
			var productTitle = this.customizeProductTitle();
			if (typeof window.chdProductTitleForDisplay === 'function') {
				productTitle = window.chdProductTitleForDisplay(productTitle);
			}
			productTitle = this._highlightSuggestionResult(productTitle, searchTerm);
			// SKU
			var skuHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductSku') && this.sku.length) {
				skuHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.SKU);
				skuHTML = skuHTML.replace(/{{sku}}/g, this.sku);
			}
			// Vendor
			var vendorHTML = '';
			if (Settings.getSettingValue('search.showSuggestionProductVendor') && this.vendor.length) {
				vendorHTML = this.getTemplate(InstantSearchResultItemProduct.tempType.VENDOR);
				vendorHTML = vendorHTML.replace(/{{vendor}}/g, this.vendor);
			}
			// Price
			var priceHTML = this.compileSuggestionProductPrice();
			// Open the result item in new tab when selected
			var newTabAttr = Settings.getSettingValue('search.openProductNewTab') ? 'target="_blank"' : '';
            var newUrl;
            if(this.url.indexOf("cart") > 0) {
              newUrl = this.url.slice(5)
            }else {
              newUrl = this.url
            }
			return this.getTemplate()
				.replace(/{{id}}/g, this.id)
				.replace(/{{escapedBlockType}}/g, Utils.stripHtml(this.parent.type))
				.replace(/{{url}}/g, newUrl)
				.replace(/{{newTabAttribute}}/g, newTabAttr)
				.replace(/{{itemProductImage}}/g, imageHTML)
				.replace(/{{title}}/g, productTitle)
				.replace(/{{escapedTitle}}/g, Utils.stripHtml(productTitle))
				.replace(/{{itemProductSku}}/g, skuHTML)
				.replace(/{{itemProductVendor}}/g, vendorHTML)
				.replace(/{{itemProductPrice}}/, priceHTML)
				.replace(/{{class.searchSuggestion}}/g, Class.searchSuggestion)
				.replace(/{{class.searchSuggestionItem}}/g, Class.searchSuggestionItem)
				.replace(/{{class.searchUiAutocompleteItem}}/g, Class.searchUiAutocompleteItem);
		} else {
			return '';
		}
    
  }

})();
